import { render, staticRenderFns } from "./sign_on.vue?vue&type=template&id=31b523c0&scoped=true&"
import script from "./sign_on.vue?vue&type=script&lang=js&"
export * from "./sign_on.vue?vue&type=script&lang=js&"
import style0 from "./sign_on.vue?vue&type=style&index=0&id=31b523c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b523c0",
  null
  
)

export default component.exports